import React from 'react'
import { NavLink, useLocation, useHistory } from 'react-router-dom'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faMapMarkerAlt, faCog, faPlus, faLayerGroup, faThList, faBook } from '@fortawesome/free-solid-svg-icons'
import './navSideBar.scss'
import { NavDropdown } from 'react-bootstrap'
import TradeDropDown from '../../assets/img/icons-dropdown.svg';


const routes = [
	{ to: '/courses', icon: <FontAwesomeIcon icon={faMapMarkerAlt} />, text: 'Courses' },
	{ to: '/classes', icon: <FontAwesomeIcon icon={faCog} />, text: 'Classes' },
	{ to: '/consumers', icon: <FontAwesomeIcon icon={faCog} />, text: 'Consumers' },
	{ to: '/jobStatus', icon: <FontAwesomeIcon icon={faCog} />, text: 'Job Status' },
	{ to: '/setupTradeRule', icon: <FontAwesomeIcon icon={faThList} />, text: 'Trade Management' },
	{ to: '/reports', icon: <FontAwesomeIcon icon={faBook} />, text: 'Reports' },
	{ to: '/logout', icon: <FontAwesomeIcon icon={faSignOutAlt} />, text: 'Log out' },
]
const tradeRuleRoutes = [
	{ to: '/setupTradeRule', icon: <FontAwesomeIcon icon={faPlus} />, text: 'Setup New Rule' },
	{ to: '/tradeRules', icon: <FontAwesomeIcon icon={faLayerGroup} />, text: 'Current Rules' },
]

const NavSideBar = () => {
	const location = useLocation();
	const history = useHistory();

	const tradeRule =
		<div className='tradeRule-tab' onClick={() => { history.push("/setupTradeRule") }}>
			<i className="material-icons link-icon"><FontAwesomeIcon icon={faThList} /></i>
			<span className="link-text">Trade Management</span>
			<img src={TradeDropDown} />
		</div>

	return (
		<nav className="main-side-nav">
			<ul className="route-list">
				{routes.map(route => (
					<li key={route.to}>
						{route && route.text === 'Trade Management' ?
							<NavDropdown
								title={tradeRule}
								show={!location.pathname.includes("Rule") ? false : true}
								menuVariant="dark"
								activeClassName="active-link"
								className="link-item">
								<ul className="tradeRule-route-list">
									{tradeRuleRoutes.map(route => (
										<li key={route.to}>
											<NavLink
												activeClassName="active-link"
												className="tradeRule-link-item"
												to={route.to}>
												<i className="material-icons link-icon">{route.icon}</i>
												<span className="link-text">{route.text}</span>
											</NavLink>
										</li>
									))}
								</ul>
							</NavDropdown> :
							<NavLink
								activeClassName="active-link"
								className="link-item"
								to={route.to}
							>
								<i className="material-icons link-icon">{route.icon}</i>
								<span className="link-text">{route.text}</span>
							</NavLink>
						}
					</li>
				))}
			</ul>
		</nav >
	)
}

export default NavSideBar
